/**
 * MeetingsRedirect — TASK-666.
 *
 * `/meetings` was a routed page; it is now a canvas widget. Old bookmarks, the nav tab and
 * any in-app link land here, get the `MeetingsList` tile summoned onto the canvas, and are
 * replaced (not pushed) onto `/dashboard`.
 *
 * `replace` matters: pushing would leave `/meetings` in history, so Back would bounce the
 * user straight through this redirect again — the loop the ticket's AC forbids.
 *
 * Summoning is idempotent — `addSpecs` is called once on mount, and `canvasStore` dedupes
 * an identical spec, so a double navigation cannot produce two tiles.
 */

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useCanvasActions } from '../stores/canvasStore';

const MeetingsRedirect: React.FC = () => {
  const { addSpecs } = useCanvasActions();

  useEffect(() => {
    addSpecs([{ component: 'MeetingsList', props: {} }]);
  }, [addSpecs]);

  return <Navigate to="/dashboard" replace />;
};

export default MeetingsRedirect;
